import React, {useCallback, useState} from "react";
import api from "../../api/room";

const initialData = {
  roomsList: [],
  deletedRoom: null,
  isCreatingRoom: false,
  createdRoom: null,
  updatedRoom: null
};

export default function useRooms() {
  const [roomsData, setRoomsData_] = React.useState(initialData);

  const [isCreatingRoom, setIsCreatingRoom] = useState(false);
  const [isDeletingRooms, setIsDeletingRooms] = useState(false);

  const setRoomsData = newData => {
    const newRoomsData = {
      ...roomsData,
      ...newData
    };

    setRoomsData_(newRoomsData);
  };

  const deleteRooms = useCallback((idList) => {
    setIsDeletingRooms(true);
    return Promise.all(idList.map(api.deleteRoom))
      .then(response => {
        setIsDeletingRooms(false);
        setRoomsData({deletedRoom: response});
      }, () => {
        setIsDeletingRooms(false);
      });
  }, [setIsDeletingRooms]);

  const createRoom = useCallback((data) => {
    setIsCreatingRoom(true);
    return api.createRoom(data)
      .then(({ data }) => {
        setIsCreatingRoom(false);
        setRoomsData({createdRoom: data});
      }, () => {
        setIsCreatingRoom(false);
      });
  }, [setIsCreatingRoom]);

  return {
    roomsData,
    deleteRooms,
    createRoom,
  isCreatingRoom,
  isDeletingRooms};
}
